import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const getAllProductsApi = async () =>
    Promise.resolve(axios.get(endpoints.getAllProducts));
